<template>
	<div class="shadowed">
		<div class="inner-content-title">
			Parâmetros gerais
		</div>
		<div class="settings-loading" v-if="loading">
			<i class="fa fa-circle-notch fa-spin"></i>
		</div>
		<div class="settings-container" v-if="!loading">
			<div class="row">
				<div class="col-xs-12">
					<div class="row">
						<div v-if="false" class="col-xs-12 col-lg-12">
							<FormInput v-model="settings.pagarme_token" label="Token do Pagar.me" icon="fa-credit-card" tooltip="Informe o token de pagamento" />
						</div>
						<div class="col-xs-12 col-md-6 col-lg-3">
							<FormSelect v-model="settings.deliveries_in_app" label="Monitorar no APP" icon="fa-mobile-alt" :options="options_deliveries" tooltip="Selecione o filtro de exibição das entregas para os motoristas no APP" />
						</div>
						<div class="col-xs-12  col-md-6 col-lg-3">
							<FormSelect v-model="settings.driver_can_reorder" label="Motorista pode reordenar carga" icon="fa-box" :options="options_reorder" tooltip="Selecione se permite o motorista reordenar a sequência das entregas na carga" />
						</div>
						<div class="col-xs-12  col-md-6 col-lg-3">
							<FormInputMasked v-model="settings.pause" label="Mostrar permanência de motorista maior que" icon="fa-stopwatch" type="text" :mask="['# min','## min','### min','#### min','##### min','###### min']" tooltip="Informe o tempo mínimo de permanência do motorista em uma região, para sua demarcação no mapa de rastreio" />
						</div>
						<div class="col-xs-12  col-md-6 col-lg-3">
							<FormInputMasked v-model="settings.radius" label="Tamanho do raio da região de permanência" icon="fa-dot-circle" type="text" :mask="['# m','## m','### m','#### m','##### m','###### m']" tooltip="Informe o tamanho padrão do raio que demarca a região de permanência do motorista no mapa de rastreio" />
						</div>
						<div class="col-xs-12  col-md-6 col-lg-3">
							<FormSelect v-model="settings.driver_send_update" label="Enviar atualização da situação de entrega" icon="fa-envelope" :options="options_send_update" tooltip="Selecione se serão enviadas atualizações da situação de entrega do pedido realizadas pelo motorista" />
						</div>
					</div>
				</div>
			</div>
			<button class="button-edit" @click="save" :disabled="!$permission.hasAreaEditPermission('Config')">
				<i class="fa fa-fw fa-save"></i> SALVAR
			</button>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect.vue";
import FormInputMasked from "../../components/FormInputMasked.vue";

export default {
	name: "ConfigSettings",

	components: {
		FormInput,
		FormSelect,
		FormInputMasked
	},

	data: function() {
		return {
			loading: true,
			original: {},
			settings: {},

			options_deliveries: {
				"0": "Somente Notas Fiscais",
				"1": "Somente Pedidos",
				"2": "Ambos",
			},
			
			options_reorder: {
				"0": "Não",
				"1": "Sim",
			},

			options_send_update: {
				"0": "Não",
				"1": "Sim",
			},
		};
	},

	computed: {
		/*diff: function() {
			for (let i in this.original) {
				if (this.settings[i] != this.original[i]) {
					return true;
				}
			}
			return false;
		}*/
	},

	mounted: function() {
		this.load();
	},

	methods: {
		load: async function() {
			this.loading = true;
			let res = await Api.post("config/load-settings");
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.original = Object.assign({}, res.data);
			this.settings = Object.assign({}, res.data);
		},

		validation: function() {
			let error = false;
			
			if (parseInt(this.settings.pause.split(" ")[0]) < 10) {
				this.$notification.error("O tempo de premanência deve ser maior ou igual a 10 min.");
				error = true;
			}
			
			if (parseInt(this.settings.radius.split(" ")[0]) < 50) {
				this.$notification.error("O tamanho da área de marcação deve ser maior ou igual a 50 metros.");
				error = true;
			}

			return error;
		},

		save: async function() {
			let result = this.validation();

			if(result) return;

			this.loading = true;
			let res = await Api.post("config/save-settings", {settings: this.settings} );
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
			} else {
				this.$notification.success("Enviado com sucesso.");
			}

			this.$notification.success("Configurações salvas com sucesso.");
			this.load();
			this.$emit("updated");
		}
	}
}
</script>

<style scoped="">
.settings-loading {
	width: 100%;
	height: 250px;
	font-size: 60px;
	text-align: center;
	line-height: 250px;
	background-color: #fff;
	color: #ccc;
}


.settings-container {
	width: 100%;
	background-color: #fff;
	padding: 15px;
}	


.button-edit {
	padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}
</style>